import ModalUI from "./ModalUI";

export default ModalUI;
